<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`"/>
            </v-row> 
            <!--table head-->
            <v-divider color="black"/>

            <v-row class="subtitle-2" no-gutters>
                <v-col cols="2"></v-col>
                <v-divider vertical color="black"></v-divider>

                <v-col cols="5" class="text-center">{{'Consumers material quality preferences' | localize }}</v-col>
                <v-divider vertical color="balck"></v-divider>
                <v-col cols="5" class="text-center">{{'Consumers manufacturing quality preferences' | localize }}</v-col>
            </v-row>
            <v-divider color="black"/>

            <v-row class="subtitle-2 text-center" no-gutters>
                <v-col class="text-left" cols="2">{{'Segment' | localize }}</v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col v-for="i in 5" :key="`mt-${i}`" cols="1">
                    {{'Level' | localize }} {{ i }}
                </v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col v-for="i in 5" :key="`mn-${i}`" cols="1">
                    {{'Level' | localize }} {{ i }}
                </v-col>
            </v-row>
            <v-divider color="black"/>
            
            <!--segments tab-->
            <div v-if="market_segments.length">
                <div v-for="segment in market_segments" :key="segment.id">
                    <v-row class="body-2 my-1" no-gutters>
                        <v-col cols="2" class="text-left text-truncate">{{ segment.segment.name }}</v-col>
                        <v-divider vertical></v-divider>
                        <v-col v-for="i in 5" :key="`mt${i}`" class="text-center">
                            {{ Math.round(segment[`material_${i}`] * 100) }}%
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col v-for="i in 5" :key="`mn${i}`" class="text-center">
                            {{ Math.round(segment[`manufacturing_${i}`] * 100) }}%
                        </v-col>
                    </v-row>
                    <v-divider />
                </div>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no information about materials & manufectures yet
            </v-row>
        </div>
        <v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
    </v-container>
</template>
<script>
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';

export default {
    name: 'MarketMaterials',
    data() {
        return {
            text: {
                en: 'This report summarises the expectations regarding manufacturing and material quality across the main market segments.',
                ro: 'Acest raport prezintă pe scurt așteptările privind calitatea producției și a materialelor în principalele segmente de piață.',
                ru: 'В данном отчете обобщены предпочтения относительно объемов производства и качества материалов в основных сегментах рынка.'
            },
        }
    },
    computed: {
        market_segments() {
            return this.$store.getters.market_segments;
        },
        game() {
            return this.$store.getters.game
        },
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
    },
    components: { Information, Loader },
}
</script>